<template>
  <tv-page title="TV标销-订单详情" :class="_.page">
    <template v-if="!loading">
      <div :class="_.detail">
        <div :class="_.left">
          <div :class="_.status">
            <img
              v-if="
                detail.status === 0 ||
                detail.status === 300 ||
                detail.status === 901
              "
              src="./images/待使用.png"
            />
            <img
              v-if="detail.status === 900 || detail.status === 902"
              src="./images/已完成.png"
            />
            <div>
              <p>
                <span v-if="detail.status === 0">待支付</span>
                <span v-if="detail.status === 300">待使用</span>
                <span v-if="detail.status === 902">交易完结</span>
              </p>
              <p
                v-for="item in detail.codeList"
                :key="item.code"
                :class="[
                  (item.status === 14 ||
                    item.status === 12 ||
                    item.status === 15) &&
                    _.delete_code,
                ]"
              >
                核销码：{{ item.code }}
              </p>
            </div>
          </div>
          <div :class="_.goods">
            <p :class="_.name">{{ detail.merchantName }}</p>
            <div :class="_.content">
              <img :src="detail.commodityPic" :class="_.cover" />
              <div>
                <p :class="_.title">
                  {{ detail.commodityName }}
                </p>
                <p :class="_.phone">
                  <img src="./images/电话.png" />
                  <span>{{ detail.merchantTel }}</span>
                </p>
                <p :class="[_.phone, _.address]">
                  <img src="./images/地址.png" />
                  <span>{{ detail.merchantAddress }}</span>
                </p>
              </div>
            </div>
          </div>
          <div :class="_.describe">
            <p>
              <span>订单金额：{{ detail.orderAmount }}元</span>
              <span
                >优惠金额：{{
                  (detail.orderAmount - detail.payAmount).toFixed(2)
                }}元</span
              >
              <span>实付金额：{{ detail.payAmount }}元</span>
            </p>
            <p>支付方式：微信支付</p>
            <p>下单时间：{{ detail.orderTime }}</p>
            <p>支付时间：{{ detail.payTime }}</p>
            <p>订单编号：{{ detail.orderNo }}</p>
          </div>
        </div>
        <div :class="_.right">
          <p :class="_.phone">平台客服电话：400-900-8799</p>
          <x-qrcode :value="url" :class="_.qrcode" :size="400" />
          <p>用多彩宝APP扫码</p>
          <p>快速打开订单详情</p>
        </div>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderWriteOffOrderDetail } from '@/api'
  import { getPageUrl } from '@/router'
  import { mapQuery, Track } from '@/utils'
  import { UserUtils } from '@/views/user/utils'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-订单详情',
      })),
      mapQuery({
        // 订单编号
        orderNo: 'orderNo',
      }),
    ],

    data() {
      return {
        // 页面加载状态
        loading: true,
        detail: '',
        url: '',
        user: {},
      }
    },

    async mounted() {
      await Promise.all([
        this.getOrderDetail(),
        UserUtils.getInfo().then(res => (this.user = res)),
      ])
      this.loading = false
      this.url = getPageUrl(
        'BookOrderDetail',
        {
          orderNo: this.orderNo,
        },
        {
          env: process.env.VUE_APP_RUN_ENV === 'production' ? 'prod' : 'test',
          user: this.user.userName,
        },
      )
      console.log('订单详情地址', this.url)
    },

    methods: {
      getOrderDetail() {
        return apiOrderWriteOffOrderDetail({
          orderNo: this.orderNo,
        }).then(res => {
          this.detail = res
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .detail {
    padding: 60px 80px;
    display: flex;

    .left {
      .status {
        width: 800px;
        background: #ffffff;
        border-radius: 12px;
        padding: 30px;
        display: flex;

        img {
          width: 50px;
          height: 50px;
          margin-right: 30px;
          margin-top: 5px;
        }

        p:first-child {
          font-size: 44px;
          font-weight: bold;
          color: #333333;
          line-height: 64px;
        }

        p:last-child {
          font-size: 28px;
          color: #333333;
          line-height: 40px;
          margin-top: 10px;
        }

        .delete_code {
          text-decoration: line-through;
        }
      }

      .goods {
        width: 860px;
        background: #ffffff;
        border-radius: 12px;
        margin: 20px 0;

        .name {
          font-size: 24px;
          color: #333333;
          line-height: 35px;
          padding: 20px;
          border-bottom: 1px solid #cccccc;
        }

        .content {
          padding: 20px;
          display: flex;

          .cover {
            width: 150px;
            height: 150px;
            border-radius: 8px;
            overflow: hidden;
            margin-right: 20px;
            object-fit: cover;
          }

          .title {
            width: 650px;
            font-size: 36px;
            font-weight: bold;
            color: #333333;
            line-height: 52px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 18px;
          }

          .phone {
            font-size: 24px;
            color: #999999;
            line-height: 35px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            img {
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
          }

          .address {
            margin-bottom: 0;
          }
        }
      }

      .describe {
        width: 800px;
        background: #ffffff;
        border-radius: 12px;
        padding: 30px;
        font-size: 24px;
        color: #999999;
        line-height: 35px;

        p {
          margin-bottom: 10px;

          span {
            margin-right: 60px;
          }

          span:last-child {
            margin-right: 0;
          }
        }

        p:last-child {
          margin-bottom: 0;
        }
      }
    }

    .right {
      width: 900px;
      font-size: 36px;
      color: #ffffff;
      line-height: 52px;
      text-align: center;

      .phone {
        font-size: 32px;
        color: #ffffff;
        line-height: 46px;
        text-align: right;
        margin-bottom: 214px;
      }

      .qrcode {
        width: 360px;
        height: 360px;
        border: 20px solid #ffffff;
        border-radius: 16px;
        margin: 0 auto 20px auto;
        background: #d8d8d8;
      }
    }
  }
</style>
